import React from 'react';
import { IconButton } from '@mui/material';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { Stack } from 'new/elements/Stack';
import Typography from 'new/elements/Typography';
import { ConnectionTypeChip } from 'new/elements/ConnectionTypeChip/ConnectionTypeChip';
import { useGetMetaInfoByConnectorType } from 'new/hooks/useGetMetaInfoByConnectorType';

import classes from './CodeEditorModeHeader.module.scss';

const connectionTypeChipStyle = { border: 'none', padding: 0 };

export interface CodeEditorModeHeaderProps {
  connectorType?: string;
  onClose?: () => void;
}

export const CodeEditorModeHeader = (props: CodeEditorModeHeaderProps) => {
  const { connectorType, onClose } = props;
  const meta = useGetMetaInfoByConnectorType(connectorType ?? '');
  const connectorLabel = meta?.name ?? connectorType ?? '';

  return (
    <Stack>
      {connectorType ? (
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          className={classes.connectorHeaderRow}
        >
          <Stack
            direction="row"
            alignItems="center"
            spacing={1.25}
            className={classes.connectorHeaderTitleGroup}
          >
            <div
              className={classes.connectorChip}
              data-testid="code-editor-connector-chip"
              aria-label={`Connector: ${connectorLabel}`}
            >
              <ConnectionTypeChip icon={meta?.iconSm} iconOnly style={connectionTypeChipStyle} />
              <div className={classes.logoSeparator} />
              <Typography variant="bodySmall" className={classes.connectorChipLabel}>
                {connectorLabel}
              </Typography>
            </div>
            <Typography variant="h3" className={classes.headerTitleWithConnector}>
              Advanced Mode
            </Typography>
          </Stack>
          <IconButton
            aria-label="Close JSON editor"
            className={classes.closeButton}
            onClick={onClose}
          >
            <CloseRoundedIcon fontSize="small" />
          </IconButton>
        </Stack>
      ) : (
        <Stack direction="row" justifyContent="space-between" alignItems="start">
          <Stack direction="row" spacing={1.25} alignItems="start">
            <div className={classes.headerIconWrapper}>
              <InsertDriveFileOutlinedIcon fontSize="small" />
            </div>
            <Typography variant="h3">Advanced Mode</Typography>
          </Stack>
          <IconButton
            aria-label="Close JSON editor"
            className={classes.closeButton}
            onClick={onClose}
          >
            <CloseRoundedIcon fontSize="small" />
          </IconButton>
        </Stack>
      )}
    </Stack>
  );
};
